import type { PaymentsActivityTranslations } from "../interfaces/paymentsActivity";

export const paymentsActivityTranslations: PaymentsActivityTranslations = {
  // Page
  page_title: "Payments activity",
  page_subtitle: "Deposits and payouts processed in real time",
  page_eyebrow: "Live monitor",
  live_updated_at: "Updated {{time}}",
  live_refresh_aria: "Refresh the list",

  stats_total: "Total",
  stats_processing: "In progress",
  stats_settled: "Settled",
  stats_failed: "Failed",
  stats_page_scope: "On this page",

  // Direction tabs
  tab_payins: "Deposits",
  tab_payouts: "Payouts",

  // Filters
  filter_status_label: "Status",
  filter_all_statuses: "All statuses",
  filter_corridor_label: "Corridor",
  filter_all_corridors: "All corridors",
  filter_date_label: "Period",
  filter_all_dates: "All history",
  filter_last_days: "Last {{days}} days",
  filter_clear: "Clear filters",

  // Status labels — one per raw backend status value (see STATUS_LABEL_KEYS); shared by pill + filter.
  status_value_created: "Pending",
  status_value_pending: "Processing",
  status_value_confirmed: "Credited",
  status_value_rejected: "Rejected",
  status_value_failed: "Failed",
  status_value_reversed: "Reversed",
  status_value_processing: "Processing",
  status_value_paid: "Paid",
  status_value_cancelled: "Cancelled",

  // Table
  table_th_status: "Status",
  table_th_corridor: "Corridor",
  table_th_amount: "Amount (net)",
  table_th_reference: "Reference",
  table_th_date: "Date",
  list_group_today: "Today",
  list_group_yesterday: "Yesterday",
  pagination_summary: "Showing {{from}}–{{to}} of {{total}}",
  copy_reference_aria: "Copy",
  copy_success: "Copied to clipboard",

  // Empty / error
  empty_title: "No activity yet",
  empty_description: "When you process a deposit or a payout it will show up here with its live status.",
  empty_filtered_description: "No activity matches the selected filters.",
  error_load: "We could not load the activity.",
  error_retry: "Retry",

  // Drawer
  drawer_title_payin: "Deposit detail",
  drawer_title_payout: "Payout detail",
  drawer_failure_reason: "Reason",
  drawer_section_qr: "Collect",
  drawer_section_amounts: "Amounts",
  drawer_amount_gross: "Gross amount",
  drawer_amount_fees: "Fees",
  drawer_amount_net: "Net amount",
  drawer_section_timeline: "Status history",
  drawer_view_ledger: "View journal entries",
  deeplink_not_found:
    "The linked operation could not be opened: it may no longer exist, belong to another organization, or the link may point at the wrong type.",
  deeplink_dismiss: "Got it",
  drawer_section_details: "Details",
  drawer_meta_id: "ID",
  drawer_meta_reference: "Reference",
  drawer_meta_concept: "Concept",
  drawer_meta_beneficiary: "Recipient",
  drawer_meta_breb_key: "Bre-B key",
  drawer_meta_breb_network_reference: "Bre-B transaction ID",
  drawer_meta_created: "Created",
  drawer_meta_expires: "Expires",
  drawer_meta_updated: "Updated",
  drawer_meta_evidence: "Evidence",
  drawer_meta_evidence_open: "Open",

  // Timeline
  timeline_step_created: "Created",
  timeline_step_processing: "Processing",
  timeline_step_credited: "Credited",
  timeline_step_paid: "Paid",
  timeline_step_failed: "Failed",
  timeline_step_cancelled: "Cancelled",
  timeline_source_staff: "Coloca team",
  timeline_source_network: "Payments network",
  timeline_source_system: "System",
  scope_title: "Filtered from Metrics",
  scope_all_organizations: "Every organization",
  scope_window_completed: "Confirmed or paid from {{from}} to {{to}}",
  scope_window_created: "Created from {{from}} to {{to}}",
  scope_clear: "Remove this filter",
};
